import {
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Header from "./Header";
import SimpleBar from "simplebar-react";
import SidebarContext from "../../../context/SidebarContext";
import { useLocation, useNavigate } from "react-router-dom";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db, storage } from "../../../firebaseConfig";
import Countries from "../../../Contries.json";
import { toast } from "react-toastify";
import FileUploadStoreImages from "../../../components/common/FileUploadStoreImages";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

export default function EditStoreData() {
  const { open } = useContext(SidebarContext);
  const location = useLocation();
  const [initialValues, setInitialValues] = useState();
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [locationData, setLocationData] = useState([]);
  const [availableStates, setAvailableStates] = useState([]);
  const [availableCities, setAvailableCities] = useState([]);

  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const docRef = collection(db, "countries");
        const querySnapshot = await getDocs(docRef);
        // Extracting data from the querySnapshot
        const countriesData = querySnapshot.docs.map((doc) => ({
          id: doc.id, // Document ID
          ...doc.data(), // Document data
        }));
        setLocationData(countriesData[0]?.locationData);
      } catch (error) {
        console.error("Error fetching location data:", error);
      }
    };

    fetchLocationData();
  }, []);

  const handleChangeTags = (event, newValue) => {
    if (newValue.length <= 2) {
      setSelectedValue(newValue);
      setInitialValues({ ...initialValues, storeDesignation: newValue });
    }
  };

  useEffect(() => {
    const getForId = async () => {
      if (location?.state?.id) {
        const docRef = doc(db, "stores", location?.state?.id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setInitialValues({
            ...docSnap.data(),
            notAffiliateLink: docSnap.data().notAffiliateLink
              ? docSnap.data().notAffiliateLink
              : false,
          });

          const selectedCountry = locationData.find(
            (country) => country.code === docSnap.data().storeLocation
          );

          const selectedState = selectedCountry?.states.find(
            (state) => state.name === docSnap.data().storeState
          );

          setAvailableStates(selectedCountry ? selectedCountry?.states : []);
          setAvailableCities(selectedState ? selectedState?.cities : []);
          if (docSnap.data().storeDesignation) {
            setSelectedValue(docSnap.data().storeDesignation);
          }
        } else {
          console.log("No such document!");
        }
      }
    };
    getForId();
  }, [location?.state?.id, locationData]);

  const uploadImage = async (file) => {
    try {
      // Create a storage reference for the file
      const storageRef = ref(storage, `/store_products/${file.name}`);

      // Upload the file and wait for the snapshot
      const uploadTask = uploadBytesResumable(storageRef, file);
      const snapshot = await uploadTask;

      // Get the downloadable URL
      const photoUrl = await getDownloadURL(snapshot.ref);

      // Return the URL for further processing
      return photoUrl;
    } catch (error) {
      console.error("Error uploading file:", error);
      return null; // Return null for failed uploads
    }
  };

  const onUploadChange = async (fileArray) => {
    setSelectedFiles(fileArray);

    try {
      const uploadedUrls = await Promise.all(
        fileArray.map((file) => uploadImage(file))
      );

      const validUrls = uploadedUrls.filter((url) => url !== null);
      setInitialValues({
        ...initialValues,
        storeImages: [...(initialValues.storeImages || []), ...validUrls],
      });
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "storeLocation") {
      const selectedCountry = locationData.find(
        (country) => country.code === value
      );
      setAvailableStates(selectedCountry ? selectedCountry.states : []);
      setAvailableCities([]);
      setInitialValues({
        ...initialValues,
        storeLocation: value,
        storeState: "",
        storeCity: "",
      });
    } else if (name === "storeState") {
      const selectedState = availableStates.find(
        (state) => state.name === value
      );
      setAvailableCities(selectedState ? selectedState.cities : []);
      setInitialValues({
        ...initialValues,
        [name]: value,
        storeCity: "",
      });
    } else {
      setInitialValues({ ...initialValues, [name]: value });
    }
  };

  const handleCancle = () => {
    navigate("/shopping/store");
  };

  const handleSave = async () => {
    try {
      if (location?.state?.id) {
        const docRef = doc(db, "stores", location?.state?.id);
        await updateDoc(docRef, initialValues);
        toast.success("Store updated successfully!");
        navigate("/shopping/store"); // Navigate to another page after saving
      }
    } catch (error) {
      console.error("Error updating store:", error);
      alert("Failed to update store. Please try again.");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
        <Header
          pageTitle={`Edit Store`}
          currentRoute={`Edit Store`}
          buttonName="Save"
          handleCancle={() => handleCancle()}
          //   loading={loading}
          handleSave={() => handleSave()}
        />
      </Box>
      <SimpleBar
        forceVisible="y"
        autoHide={true}
        style={{
          maxHeight: "82vh",
        }}
        className="custom-scrollbar"
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box>
              <Stack direction={"row"} sx={{ marginTop: "20px" }} gap={3}>
                <Grid item>
                  <FileUploadStoreImages
                    name="images"
                    onChange={onUploadChange}
                    refresh={selectedFiles}
                    typePage="storeDetailEdit"
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                  />
                </Grid>
              </Stack>

              <Stack sx={{ marginTop: "20px" }}>
                <Grid item>
                  <Box sx={{ marginBottom: "0px" }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                      Name
                    </Typography>
                  </Box>
                  <FormControl
                    fullWidth
                    sx={{
                      mt: 1,
                      minWidth: "30vw",
                      minHeight: "35px",
                      marginLeft: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="text"
                      id="name"
                      placeholder="Enter Name"
                      name="storeName"
                      sx={{ height: "35px" }}
                      value={initialValues?.storeName}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
              </Stack>
              <Stack sx={{ marginTop: 2 }}>
                <Grid item>
                  <Box>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Country
                    </Typography>
                  </Box>
                  <FormControl
                    fullWidth
                    sx={{ mt: 1, minWidth: "30vw", minHeight: "35px" }}
                    size="small"
                  >
                    <Select
                      value={initialValues?.storeLocation || ""}
                      displayEmpty
                      fullWidth
                      name="storeLocation"
                      sx={{ height: "35px" }}
                      onChange={handleChange}
                    >
                      <MenuItem value="" disabled>
                        Select Country
                      </MenuItem>
                      {locationData &&
                        locationData?.length > 0 &&
                        locationData.map((country) => (
                          <MenuItem key={country.code} value={country.code}>
                            {country.country}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Stack>

              <Stack sx={{ marginTop: 2 }}>
                <Grid item>
                  <Box>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      State
                    </Typography>
                  </Box>
                  <FormControl
                    fullWidth
                    sx={{
                      mt: 1,
                      minWidth: "30vw",
                      minHeight: "35px",
                      marginLeft: "0px",
                    }}
                    size="small"
                  >
                    <Select
                      displayEmpty
                      name="storeState"
                      sx={{ height: "35px" }}
                      value={initialValues?.storeState || ""}
                      onChange={handleChange}
                      disabled={!availableStates.length}
                    >
                      <MenuItem value="" disabled>
                        Select State
                      </MenuItem>
                      {availableStates.map((state) => (
                        <MenuItem key={state.name} value={state.name}>
                          {state.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Stack>

              <Stack sx={{ marginTop: 2 }}>
                <Grid item>
                  <Box>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      City
                    </Typography>
                  </Box>
                  <FormControl
                    fullWidth
                    sx={{
                      mt: 1,
                      minWidth: "30vw",
                      minHeight: "35px",
                      marginLeft: "0px",
                    }}
                    size="small"
                  >
                    <Select
                      displayEmpty
                      name="storeCity"
                      sx={{ height: "35px" }}
                      value={initialValues?.storeCity || ""}
                      onChange={handleChange}
                      disabled={!availableCities.length} // Disable if no cities are available
                    >
                      <MenuItem value="" disabled>
                        Select City
                      </MenuItem>
                      {availableCities.map((city) => (
                        <MenuItem key={city} value={city}>
                          {city}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Stack>

              <Stack sx={{ marginTop: 2 }}>
                <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                  Store Designation
                </Typography>
                <Autocomplete
                  size="small"
                  sx={{ height: "35px", mt: 1 }}
                  multiple
                  options={["Top picks today", "Top ship"]}
                  freeSolo
                  value={selectedValue}
                  onChange={handleChangeTags}
                  renderInput={(params) => (
                    <TextField
                      sx={{ height: "35px" }}
                      {...params}
                      placeholder="Search"
                      size="small"
                    />
                  )}
                  renderTags={() => null}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    marginTop: "8px",
                  }}
                >
                  {selectedValue.map((tag, index) => (
                    <Chip
                      sx={{
                        backgroundColor: "rgba(238, 238, 238, 1)",
                        fontSize: "14px",
                        fontWeight: 500,
                        height: "28px",
                      }}
                      key={index}
                      label={tag}
                      onDelete={() => {
                        const updatedValue =
                          initialValues.storeDesignation.filter(
                            (_, i) => i !== index
                          );

                        // Update initialValues with the updated array
                        setInitialValues((prev) => ({
                          ...prev,
                          storeDesignation: updatedValue,
                        }));

                        setSelectedValue((prev) =>
                          prev.filter((_, i) => i !== index)
                        );
                      }}
                    />
                  ))}
                </Box>
              </Stack>
              <Stack sx={{ marginTop: 2 }}>
                <Box sx={{ marginBottom: "10px" }}>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600" }}>
                    Description (limit to 50 words max)
                  </Typography>
                </Box>
                <FormControl
                  fullWidth
                  sx={{
                    mt: 1,
                    minWidth: "30vw",
                    minHeight: "50px",
                    marginLeft: "0px",
                  }}
                  size="small"
                >
                  <OutlinedInput
                    type="text"
                    id="description"
                    placeholder="Enter"
                    name="storeDescription"
                    multiline={true}
                    minRows={5}
                    maxRows={5}
                    inputProps={{ maxLength: 50 }}
                    value={initialValues?.storeDescription}
                    onChange={handleChange}
                  />
                </FormControl>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </SimpleBar>
    </Box>
  );
}
